export const SHARE_UID = 'shareUid';
